import { Link } from '@/navigation';
import { useToggle } from '@react-hookz/web';
import { useTranslations } from 'next-intl';
import type { MouseEvent, ReactNode } from 'react';

interface BaseProps {
  text: ReactNode;
  className?: string;
}

interface NoLinkProps {
  isLink?: never;
  href?: never;
  expandedText?: ReactNode;
}

interface LinkProps {
  isLink: boolean;
  href: string;
  expandedText?: never;
}

type Props = BaseProps & (NoLinkProps | LinkProps);

export const ExpandedText = ({
  text,
  expandedText,
  className,
  href,
  isLink,
}: Props) => {
  const t = useTranslations('login');
  const [isExpanded, toggleExpanded] = useToggle(false);

  const handleToggleExpanded = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    toggleExpanded();
  };

  return expandedText ? (
    <p className={className}>
      {text}
      &nbsp;
      <u className="cursor-pointer" onClick={handleToggleExpanded}>
        {t('read_more')}
      </u>
      <br />
      {isExpanded && expandedText}
    </p>
  ) : (
    <p className={className}>
      {text}{' '}
      {isLink && (
        <Link href={href} target="_blank" className="cursor-pointer underline">
          {t('read_more')}
        </Link>
      )}
    </p>
  );
};
